import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from 'react-redux';
import { BrButton } from "@govbr-ds/webcomponents-react";
import { exibeMensagemErro, limpaMensagem } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { getMessagemErro } from "../../utils/erro";
import api from "../../services/api";
import "./PopupHistoricoTransferencia.css";

const mapDispatchToProps = { exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando };

const mapStateToProps = (state) => ({
	user: state.usuarioStore.user,
});

const HistoricoTable = ({ historicos }) => {
	if (!historicos || historicos.length === 0) {
		return <p style={{ padding: '20px', textAlign: 'center' }}>Sem histórico disponível.</p>;
	}

	const formatarData = (dataStr) => {
		if (!dataStr) return '-';
		const data = new Date(dataStr);
		const dia = String(data.getDate()).padStart(2, '0');
		const mes = String(data.getMonth() + 1).padStart(2, '0');
		const ano = data.getFullYear();
		const hora = String(data.getHours()).padStart(2, '0');
		const minuto = String(data.getMinutes()).padStart(2, '0');
		return `${dia}/${mes}/${ano} ${hora}:${minuto}`;
	};

	const historicosOrdenados = [...historicos].reverse();

	return (
		<div className="historico-table-wrapper">
			<table className="historico-table">
				<thead>
					<tr>
						<th>Evento</th>
						<th>Status Anterior</th>
						<th>Status Novo</th>
						<th>Descrição</th>
						<th>Cód. Erro</th>
						<th>Detalhe do Erro</th>
						<th>Data do Evento</th>
					</tr>
				</thead>
				<tbody>
					{historicosOrdenados.map((item, index) => (
						<tr key={index}>
							<td style={item.evento === 'ERRO' ? { color: 'red' } : undefined}>{item.evento || '-'}</td>
							<td>{item.statusAnterior || '-'}</td>
							<td>{item.statusNovo || '-'}</td>
							<td>{item.descricao || '-'}</td>
							<td>{item.codigoErro || '-'}</td>
							<td style={{ maxWidth: '220px', wordBreak: 'break-word' }}>{item.mensagemErro || '-'}</td>
							<td>{formatarData(item.dataEvento)}</td>
						</tr>
					))}
				</tbody>
			</table>
		</div>
	);
};

export const PopupHistoricoTransferencia = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(
		class extends Component {

			constructor(props) {
				super(props);
				this.state = {
					historicos: null,
					carregando: true,
					erro: null,
				};
				this.fecharPopup = this.fecharPopup.bind(this);
			}

			componentDidMount() {
				this.carregarHistorico();
			}

			carregarHistorico() {
				const { idTransferencia } = this.props;
				
				this.props.mostraAguardando();
				this.setState({ carregando: true, erro: null });

				api.get(`/api/transferencia-arquivo-grandes-volumes/${idTransferencia}/historico`)
					.then((response) => {
						// response.data contém { idTransferencia, historicos[] }
						const historicos = response.data.historicos || [];
						this.setState({ historicos, carregando: false });
					})
					.catch((erro) => {
						const msg = getMessagemErro("Não foi possível carregar o histórico", erro);
						this.setState({ 
							erro: msg.mensagem, 
							carregando: false,
							historicos: []
						});
						this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					})
					.then(() => {
						this.props.escondeAguardando();
					});
			}

			fecharPopup() {
				this.props.onClose();
			}

			render() {
				const { historicos, carregando, erro } = this.state;
				const { idTransferencia } = this.props;

				return (
					<div className="popup-overlay" onClick={this.fecharPopup}>
						<div className="popup-modal" onClick={(e) => e.stopPropagation()}>
							<div className="popup-header">
								<h2>Histórico de Transferência #{idTransferencia}</h2>
								<button 
									type="button" 
									className="popup-close-btn"
									onClick={this.fecharPopup}
									aria-label="Fechar"
								>
									✕
								</button>
							</div>

							<div className="popup-content">
								{carregando ? (
									<div className="popup-loading">Carregando histórico...</div>
								) : erro ? (
									<div className="popup-error">{erro}</div>
								) : (
									<HistoricoTable historicos={historicos} />
								)}
							</div>

							<div className="popup-footer">
								<div className=".buttons-footer">
									<BrButton emphasis="secondary" onClick={this.fecharPopup} >
											Fechar
									</BrButton>
								</div>
							</div>
						</div>
					</div>
				);
			}
		}
	)
);
